module.exports = __webpack_public_path__ + "static/coralorganicmain-cd4c1e16024b8999f5161b4a43c84c4b.jpeg";